export enum FolderModelState {
	ACTIVE = 'ACTIVE',
	ARCHIVED = 'ARCHIVED'
}
